export function fmtBrl(v: number) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v ?? 0);
}

export function fmtBrlShort(v: number) {
    if (Math.abs(v) >= 1_000_000) return `R$ ${(v / 1_000_000).toFixed(1)}M`;
    if (Math.abs(v) >= 1_000) return `R$ ${(v / 1_000).toFixed(0)}k`;
    return fmtBrl(v);
}

export function monthLabel(ym: string, locale: string) {
    const [y, m] = ym.split('-').map(Number);
    if (!y || !m) return ym;
    return new Date(y, m - 1, 1).toLocaleDateString(locale, { month: 'long', year: 'numeric' });
}

export function monthLabelCap(ym: string, locale: string) {
    const label = monthLabel(ym, locale);
    return label.charAt(0).toUpperCase() + label.slice(1);
}

export function currentMonthKey(d = new Date()) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function shiftMonthKey(ym: string, delta: number) {
    const [y, m] = ym.split('-').map(Number);
    const d = new Date(y, m - 1 + delta, 1);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function monthOptions(fromYm: string, count = 18): string[] {
    const out: string[] = [];
    for (let i = 0; i < count; i++) {
        out.push(shiftMonthKey(fromYm, -i));
    }
    return out;
}
